document.addEventListener("click", function (e) {
  // 点击打开弹窗
  if (e.target.classList.contains("icon_text_click-text")) {
    const id = e.target.getAttribute("id");
    const popup = document.querySelector(`.popup-box[data-popup="${id}"]`);
    if (popup) popup.classList.add("active");
  }

  // 点击关闭（X 按钮 或者遮罩）
  if (
    e.target.classList.contains("popup-overlay") ||
    e.target.classList.contains("popup-close")
  ) {
    e.target.closest(".popup-box").classList.remove("active");
  }
});

// 产品详情页 折扣码复制
document.querySelectorAll(".copy-discount-btn").forEach(function (btn) {
  btn.addEventListener("click", function () {
    const targetId = this.getAttribute("data-target");
    const text = document.getElementById(targetId).innerText;

    navigator.clipboard.writeText(text).then(() => {
      this.innerText = "Copied";
      setTimeout(() => {
        this.innerText = "Copy Code";
      }, 2000);
    });
  });
});
